module.exports = __webpack_public_path__ + "img/img-empty.d5aae1a9.svg";